import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './design/tokens.css';
import './index.css';
import './styles/calculadora-mobile.css'; // Responsividade mobile das calculadoras (PC intacto)
import './styles/high-contrast-fix.css';
import './styles/library-high-contrast-override.css'; // Adiciona override para bibliotecas
import './styles/high-contrast-specific-override.css'; // Override extremamente específico
import { GoogleOAuthProvider } from '@react-oauth/google';
import ResultadosPendentes from './components/Utils/ResultadosPendentes';
import { Toaster } from './components/ui/toaster';
import { startVersionCheck } from './utils/versionCheck';
import { iniciarReporterDeFalhas } from './services/reporterDeFalhas';
import { lockPortrait } from './utils/lockOrientation';
import { registarAppDeArranque, registarAberturaNoBackend } from './utils/clubPwa';
import { setupHighContrastDetection } from './utils/highContrastDetection';
import { createConsoleBanner, setupGlobalObject } from './utils/consoleBanner';
import { createProductionBanner, setupProductionGlobals } from './utils/productionConsole';
import { shouldShowProductionBanner } from './config/domains';

// Disable browser automatic scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Deteção automática de nova versão (limpa cache + reload quando há deploy novo)
startVersionCheck();
// Envia para o servidor as falhas que ficaram na fila (ver reporterDeFalhas)
iniciarReporterDeFalhas();

// Bloqueia a orientação em vertical (best-effort; manifest já é portrait)
lockPortrait();

// Initialize high contrast mode detection
setupHighContrastDetection();

// 🎮 Display PadelMaster console banner
createConsoleBanner();

// Setup global PadelMaster object for developers
setupGlobalObject();

// Setup production-specific features if on official domains
if (shouldShowProductionBanner()) {
  createProductionBanner().then(() => {
    setupProductionGlobals();
  });
}

// Supondo que você tenha um elemento com id 'root' no seu HTML
// Antes de o React encaminhar seja o que for: o ?app= do arranque só existe
// na primeira navegação.
registarAppDeArranque();

// Regista no backend que esta app abriu (versão + que app é). Não se espera
// por isto: se falhar, a app abre na mesma.
void registarAberturaNoBackend(
  __APP_VERSION__,
  window.location.pathname.match(/^\/club\/([^/]+)\//)?.[1],
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <React.StrictMode>
        <App />
        <Toaster />
        <ResultadosPendentes />
      </React.StrictMode>
    </GoogleOAuthProvider>
  );
}
